import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { showNotification } from 'src/app/helpers/show-toast';
import { AllSpecialitiesData } from 'src/app/_models/allSpecialities.model';
import { AllSpecialitiesApi } from 'src/app/_services/allSpecialities.service';

@Component({
  selector: 'app-add-speciality',
  templateUrl: './add-speciality.component.html',
  styleUrls: ['./add-speciality.component.scss'],
})
export class AddSpecialityComponent implements OnInit {
  pageTitle: string = 'Specialities';
  ranks = Array(15);
  imageFile;
  featuredSpecialityImage;
  editMode = false;

  specialityData: AllSpecialitiesData = { isActive: true, isAnonymous: false };

  addSpecialityForm: FormGroup;
  isSubmited: boolean = false;
  specialityFileName: string = '';
  specialityFeaturedImageName: string = '';

  constructor(
    private specilialityService: AllSpecialitiesApi,
    private activatedRoute: ActivatedRoute,
    public toastr: ToastrService,
    private router: Router,
    private spinner: NgxSpinnerService,
    private _formBuilder: FormBuilder
  ) {}

  ngOnInit(): void {
    this.addSpecialityForm = this._formBuilder.group({
      enSpecialityName: [null, [Validators.required, Validators.pattern(/^[A-Za-z][A-Za-z0-9 .-]*$/)]],
      arSpecialityName: [null, [Validators.required, Validators.pattern(/^[\u0621-\u064A0-9 .-]+$/)]],
      specialityActiveCheck: [false, [Validators.required]],
      specialityAnonymousCheck: [false, [Validators.required]],
      specialityRank: [null],
      specialityFileInput: [null, [Validators.required]],
      specialityFeaturedImage: [null],
    });

    this.editMode =
      this.activatedRoute.snapshot.url[1] &&
      this.activatedRoute.snapshot.url[1].path === 'edit' &&
      true;

    if (this.editMode) {
      const id = this.activatedRoute.snapshot.params.specialtyId;
      this.specilialityService.getSpecialityById(id).subscribe((res) => {
        this.specialityData = res.data;


        this.specialityFileName = this.specialityData.imagePath?.split('/').pop();
        this.specialityFeaturedImageName = this.specialityData.featuredImage?.split('/').pop();

        this.addSpecialityForm.controls['enSpecialityName'].setValue(this.specialityData.name);
        this.addSpecialityForm.controls['arSpecialityName'].setValue(this.specialityData.arName);
        this.addSpecialityForm.controls['specialityActiveCheck'].setValue(this.specialityData.isActive);
        this.addSpecialityForm.controls['specialityAnonymousCheck'].setValue(this.specialityData.isAnonymous);
        this.addSpecialityForm.controls['specialityRank'].setValue(this.specialityData.rank);
        this.addSpecialityForm.controls['specialityFileInput'].setValue(this.specialityFileName);
        this.addSpecialityForm.controls['specialityFeaturedImage'].setValue(this.specialityFeaturedImageName);
      });
    }
  }

  onAddSpecialitySubmit() {
    this.isSubmited = true;

    this.specialityData.name = this.addSpecialityForm.value.enSpecialityName;
    this.specialityData.arName = this.addSpecialityForm.value.arSpecialityName;
    this.specialityData.isActive = this.addSpecialityForm.value.specialityActiveCheck;
    this.specialityData.isAnonymous = this.addSpecialityForm.value.specialityAnonymousCheck;
    this.specialityData.rank = this.addSpecialityForm.value.specialityRank;

    if (!this.specialityData.rank) {
      this.addSpecialityForm.controls['specialityFeaturedImage'].setValidators([Validators.required]);
    } else {
      this.addSpecialityForm.controls['specialityFeaturedImage'].clearValidators();
    }

    this.addSpecialityForm.controls['specialityFeaturedImage'].updateValueAndValidity();

    if(this.addSpecialityForm.valid) {

      if (this.editMode) {
        this.specilialityService
        .updateSpecialty(this.specialityData)
        .subscribe((res) => {
          showNotification(
            'success',
            `${res.data.name} has been updated`,
            this.toastr
          );
          this.spinner.hide();
          this.router.navigateByUrl('specialties');
        });
      } else {
        this.specilialityService
        .addSpecialty(this.specialityData)
        .subscribe((res) => {
          showNotification(
            'success',
            `${res.data.name} has been added`,
            this.toastr
          );
          this.spinner.hide();

          this.router.navigateByUrl('specialties');
        });
      }
    } else {
      showNotification(
        'danger',
        'You should fill the form fields with the correct data!',
        this.toastr
      );
    }
  }

  onImageUpload(imageFile): void {
    // this.imageFile = imageFile.target.files[0];
    // this.specialityData.Image = imageFile.target.files[0];

    this.imageFile = imageFile.target.files[0];
    this.specialityFileName = this.imageFile.name;
    this.addSpecialityForm.controls['specialityFileInput'].setValue(imageFile ? this.specialityFileName : '');

    this.specialityData.Image = this.imageFile;
  }
  onFeaturedSpecialityImageUpload(imageFile): void {
    // this.featuredSpecialityImage = imageFile.target.files[0];
    // this.specialityData.FeaturedSpecialityImage = imageFile.target.files[0];

    this.featuredSpecialityImage = imageFile.target.files[0];
    this.specialityFeaturedImageName = this.featuredSpecialityImage.name;
    this.addSpecialityForm.controls['specialityFeaturedImage'].setValue(imageFile ? this.specialityFeaturedImageName : '');

    this.specialityData.FeaturedSpecialityImage = this.featuredSpecialityImage;
  }

  onAddLatestOffer(): void {
    this.spinner.show();


    if (this.editMode) {
      this.specilialityService
        .updateSpecialty(this.specialityData)
        .subscribe((res) => {
          showNotification(
            'success',
            `${res.data.name} has been updated`,
            this.toastr
          );
          this.spinner.hide();
          this.router.navigateByUrl('specialties');
        });
    } else {
      this.specilialityService
        .addSpecialty(this.specialityData)
        .subscribe((res) => {
          showNotification(
            'success',
            `${res.data.name} has been added`,
            this.toastr
          );
          this.spinner.hide();

          this.router.navigateByUrl('specialties');
        });
    }
  }
}
